//questionnaire页面所需数据

import { name } from "file-loader";

export const questionnaire = [
  "Please take your time to read and respond to each survey question truthfully with accurate information. The reason you are given the opportunity to make money online with surveys is because the researchers need your valuable input. If you are not being honest, your answers are not useful and you’ll quickly find yourself with no surveys to complete. ",
  "Your survey sessions are to be kept strictly confidential and you cannot share with anyone any of its content, including texts, images, videos and your answers. This also means that you cannot show others what answers to give that may help them qualify, through any method (e.g. videos, forums, articles, chats, etc)."
];

//rewards下一级所需数据
export const paypal = {
  imgurl: require("@/assets/pcImg/paypal.png"),
  name: "PayPal",
  title: "PayPal Rewards: Select Your PayPal Payment",
  pList: [
    "Put money directly into your PayPal account and use at millions of online stores. ",
    "For the quickest delivery of your payment, we recommend that your PayPal account email matches to the email registered for your account. Your first and last name needs to be an exact match to your PayPal account information and your PayPal account needs to be verified. Verifying your PayPal account consists of linking a bank account to your PayPal account, being approved for PayPal Smart Connect, or PayPal Plus MasterCard®. ",
    "To verify your PayPal account, we have provided the following link below. If you have trouble completing PayPal verification, please contact PayPal directly for help troubleshooting."
  ],
  explain:
    "* While every attempt is made to process your redemption as soon as possible, rewards may take up to 10 business days to receive, although they usually arrive much sooner. "
};
export const walmart = {
  imgurl: require("@/assets/pcImg/walmart.png"),
  name: "Walmart",
  title: "PayPal Rewards: Select Your PayPal Payment",
  pList: [
    "Put money directly into your PayPal account and use at millions of online stores. ",
    "For the quickest delivery of your payment, we recommend that your PayPal account email matches to the email registered for your account. Your first and last name needs to be an exact match to your PayPal account information and your PayPal account needs to be verified. Verifying your PayPal account consists of linking a bank account to your PayPal account, being approved for PayPal Smart Connect, or PayPal Plus MasterCard®. ",
    "To verify your PayPal account, we have provided the following link below. If you have trouble completing PayPal verification, please contact PayPal directly for help troubleshooting."
  ],
  explain:
    "* While every attempt is made to process your redemption as soon as possible, rewards may take up to 10 business days to receive, although they usually arrive much sooner. "
};
export const amazon = {
  imgurl: require("@/assets/pcImg/amazon.png"),
  name: "Amazon",
  title: "Amazon Rewards: Select Your Amazon Gift Card",
  pList: [
    "ySense Amazon.com’s huge selection includes products in Books, Electronics, Music, DVD, Video, Apparel, Computers, Software, Sports & Outdoors, Toys, Baby, Computer & Video Games, Kitchen & Housewares, Jewelry, Beauty, Cell Phones & Service, Tools & Hardware, Office Products, Camera & Photo, Pet Supplies, and more. Amazon.com is the place to find and discover anything you want to buy online at a great price. ",
    "RESIDENTS OF CANADA - Please note: Amazon.com gift cards are NOT redeemable on Amazon.ca.",
    "*Amazon.com is not a sponsor of this promotion. Except as required by law, GCs cannot be transferred for value or redeemed for cash. GCs may be used only for purchases of eligible goods on Amazon.com or certain of its affiliated websites. For complete terms and conditions, see www.amazon.com/gc-legal. GCs are issued by ACI Gift Cards, Inc., a Washington corporation. ©,®,™ Amazon.com Inc. and/or its affiliates, 2013."
  ],
  explain:
    "* While every attempt is made to process your redemption as soon as possible, rewards may take up to 3- 10 business days to receive, although they usually arrive much sooner. "
};

//兑换列表，测试用
export const list = [
  { date: "8th March,2023", prizeName: "amazon", status: "Obtained" },
  { date: "8th March,2023", prizeName: "amazon", status: "Obtained" },
  { date: "8th March,2023", prizeName: "amazon", status: "Obtained" },
  { date: "8th March,2023", prizeName: "amazon", status: "Obtained" },
  { date: "8th March,2023", prizeName: "amazon", status: "Obtained" },
  { date: "8th March,2023", prizeName: "amazon", status: "Obtained" },
  { date: "8th March,2023", prizeName: "amazon", status: "Obtained" },
  { date: "8th March,2023", prizeName: "amazon", status: "Obtained" },
  { date: "8th March,2023", prizeName: "amazon", status: "Obtained" },
  { date: "8th March,2023", prizeName: "amazon", status: "Obtained" },
  { date: "8th March,2023", prizeName: "amazon", status: "Obtained" },
  { date: "8th March,2023", prizeName: "amazon", status: "Obtained" },
  { date: "8th March,2023", prizeName: "amazon", status: "Obtained" },
  { date: "8th March,2023", prizeName: "amazon", status: "Obtained" },
  { date: "8th March,2023", prizeName: "amazon", status: "Obtained" },
  { date: "8th March,2023", prizeName: "amazon", status: "Obtained" },
  { date: "8th March,2023", prizeName: "amazon", status: "Obtained" },
  { date: "8th March,2023", prizeName: "amazon", status: "Obtained" },
  { date: "8th March,2023", prizeName: "amazon", status: "Obtained" },
  { date: "8th March,2023", prizeName: "amazon", status: "Obtained" },
  { date: "8th March,2023", prizeName: "amazon", status: "Obtained" },
  { date: "8th March,2023", prizeName: "amazon", status: "Obtained" },
  { date: "8th March,2023", prizeName: "amazon", status: "Obtained" },
  { date: "8th March,2023", prizeName: "amazon", status: "Obtained" },
  { date: "8th March,2023", prizeName: "amazon", status: "Obtained" },
  { date: "8th March,2023", prizeName: "amazon", status: "Obtained" },
  { date: "8th March,2023", prizeName: "amazon", status: "Obtained" },
  { date: "8th March,2023", prizeName: "amazon", status: "Obtained" },
  { date: "8th March,2023", prizeName: "amazon", status: "Obtained" },
  { date: "8th March,2023", prizeName: "amazon", status: "Obtained" },
  { date: "8th March,2023", prizeName: "amazon", status: "Obtained" },
  { date: "8th March,2023", prizeName: "amazon", status: "Obtained" },
  { date: "8th March,2023", prizeName: "amazon", status: "Obtained" }
];

// 获得数据
export const getList = (pages, pageNumber) => {
  const list = [];
  
  console.log(list);
  return list;
};



// WEBPACK FOOTER //
// ./src/utlis/storageData.js